import {SocialAccountList, SocialAccountRestControllerApiFactory, SocialConnectRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {SoftChip, PersonAvatar, euros} from "../../../../components/kit";
import {Box, Stack, Typography} from "@mui/material";
import {SOCIAL_ACCOUNT_STATUS, SOCIAL_PROVIDER} from "../labels";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";
import {FormButtonProps} from "../../../../components/form/form_inputs/form_button";
import dayjs from "dayjs";

export const SocialAccountListPage = () => {
    const apiManager = useApiManager();

    // asMember solo aplica a LinkedIn: true = perfil personal, false = página de empresa.
    // Ambas cuentas pueden convivir (se guardan con externalId distinto).
    const connect = (provider: string, asMember?: boolean) => {
        const ctrl = apiManager.factory(SocialConnectRestControllerApiFactory);
        apiManager.execute(ctrl.connect(provider, asMember)).then((res) => {
            const authUrl = res?.["authUrl"];
            if (authUrl) {
                window.open(authUrl, "_blank", "noopener");
            } else {
                apiManager.enqueueSnackbar("No se obtuvo la URL de autorización", {variant: "warning"});
            }
        });
    };

    const listConfig: AppListConfig<SocialAccountList> = {
        title: "Cuentas sociales",
        onClick: "/app/admin/marketing/social-account",
        actions: [
            {label: "Conectar Facebook/Instagram", action: () => connect("facebook")} as FormButtonProps,
            {label: "Conectar LinkedIn (empresa)", action: () => connect("linkedin", false)} as FormButtonProps,
            {label: "Conectar LinkedIn (perfil)", action: () => connect("linkedin", true)} as FormButtonProps,
        ],
        headers: [
            {title: "Red"},
            {title: "Nombre"},
            {title: "Id externo"},
            {title: "Estado"},
            {title: "Caduca"},
        ],
        decorator: (bean: SocialAccountList) => (
            <>
                <TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>{bean.provider ? (SOCIAL_PROVIDER[bean.provider] ?? bean.provider) : "—"}</TableCell>
                <TableCell>{bean.name ?? "-"}</TableCell>
                <TableCell>{bean.externalId ?? "-"}</TableCell>
                <TableCell>{bean.status ? <SoftChip label={SOCIAL_ACCOUNT_STATUS[bean.status]?.label ?? bean.status} tone={SOCIAL_ACCOUNT_STATUS[bean.status]?.tone ?? "neutral"}/> : "—"}</TableCell>
                <TableCell>{bean.expiresAt ? dayjs(bean.expiresAt).format("DD/MM/YYYY") : "-"}</TableCell>
            </>
        ),
        supplier: async (currentPage, size, term, showDismissed) => {
            const ctrl = apiManager.factory(SocialAccountRestControllerApiFactory);
            return ctrl.pageSocialAccount(currentPage, size, undefined, undefined, undefined, term, showDismissed);
        },
    };

    return <AppList config={listConfig}/>;
};
